import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../environments/environment';

import { Espectaculo } from '../models/espectaculo';
import { EspectaculoService } from '../services/espectaculo.service';
@Component({
  selector: 'app-espectaculo',
  templateUrl: './espectaculo.component.html',
  styleUrls: ['./espectaculo.component.css']
})
export class EspectaculoComponent implements OnInit {

  model: Espectaculo = new Espectaculo();
  url = environment.imgUrl;

  constructor(private modelService: EspectaculoService, private route: ActivatedRoute) {
    this.model.id = Number(this.route.snapshot.paramMap.get('id'));
  }

  ngOnInit() {
    this.modelService.get(this.model.id).subscribe(val => {
      this.model = val;
    });
  }

}
